import styled from 'styled-components';
import { Color } from '../../../../../common/view/color/color';

const Container = styled.div.withConfig({
  componentId: 'progress-bar_container',
  displayName: 'ProgressBar',
})`
  width: 100px;
  height: 4px;
  border-radius: 4px;
  background: ${Color.white9};
  overflow: hidden;
  /* border: 1px solid ${'#007FFF'}; */
`;

const Bar = styled.div.withConfig({
  componentId: 'progress-bar_bar',
  displayName: 'ProgressBar.Bar',
})`
  height: 100%;
  background: ${'#007FFF'};
  transition: width 0.2s ease;
`;

export const ProgressBarStyle = {
  Container,
  Bar,
};
